var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#336",
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M387.644 368L435 145H125.27L78 368z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.901 153.957s172.288 35.335 175.685 35.944c39.545 6.962 38.325 14.62 38.325 14.62 27.699-.173 31.183.958 35.973 5.048 14.546 12.185-9.145 48.041-9.145 48.041C369.342 260.134 113 359 113 359h268.188L425 153H131.901v.957",
    fill: "#336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.65 220.386c-3.905 1.91-13.97 2.953-18.743 3.387-4.6.348-5.814.869-5.901 2.606-.087 1.564.694 2.432 7.202 2.432 15.012 0 41.998-5.646 50.155-3.04 4.338 1.39.868 9.034-2.69 19.11-1.388 3.909 1.301 3.648 2.863 1.91 1.562-1.736 8.59-14.505 9.372-21.107 1.041-9.294-6.855-10.684-17.875-10.684H339.59c-.954 0-1.648.608-2.776 2.085-.868 1.216-1.65 1.998-4.166 3.3",
    fill: "#336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.642 201.111L88 360s103.19-50.722 115.741-57.182c25.885-13.27 61.618-30.905 94.65-42.167 6.275-2.183 33.293-10.476 48.98-13.27 6.102-1.135 8.629-2.095 8.629-3.317-.261-3.23-6.362-3.492-16.734-2.969-31.637 1.484-92.21 25.667-109.64 34.834l-19.697-61.111H335.78c5.665-15.89-74.517-13.62-76.957-13.794H121.642v.087",
    fill: "#336"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsps);
export default __webpack_public_path__ + "static/media/usps.1261c51053c762e382810ee2946b746b.svg";
export { ForwardRef as ReactComponent };